import { render, staticRenderFns } from "./LanguageSelector.vue?vue&type=template&id=7ab3be20&scoped=true"
import script from "./LanguageSelector.vue?vue&type=script&lang=js"
export * from "./LanguageSelector.vue?vue&type=script&lang=js"
import style0 from "@/assets/css/components/language-selector.less?vue&type=style&index=0&id=7ab3be20&prod&scoped=true&lang=less&external"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ab3be20",
  null
  
)

export default component.exports